import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { selectUser, logout } from '../../Apis/store/authSlice';
import { apiSlice } from '../../Apis/store/apiSlice';

const LogoutButton = ({ className = "", showText = true, children }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    
    try {
      // Add a small delay for better UX
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Clear all RTK Query cache before logout
      dispatch(apiSlice.util.resetApiState());
      
      // Clear user data and tokens
      dispatch(logout());
      
      // Show success toast
      toast.success('تم تسجيل الخروج بنجاح');
      
      // Navigate to login page
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
      toast.error('حدث خطأ أثناء تسجيل الخروج');
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoggingOut}
      className={`${className} ${
        isLoggingOut ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'
      } transition-opacity duration-200`}
      title={user ? `تسجيل خروج ${user.name || user.national_id}` : 'تسجيل خروج'}
    >
      {children || (
        <div className="flex items-center">
          {isLoggingOut ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
              جاري تسجيل الخروج...
            </>
          ) : (
            <>
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              {showText && 'تسجيل خروج'}
            </>
          )}
        </div>
      )}
    </button>
  );
};

export default LogoutButton;

